// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.t2Kw4rGu7sLhQ5GTkVbZ {
  height: 100%;
  width: 100%;
  padding-right: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/FlowSheetEditor/components/RightPanel/UnitPanel/components/StreamUnit/MainTab/styles.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;AACF","sourcesContent":[".container {\n  height: 100%;\n  width: 100%;\n  padding-right: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `t2Kw4rGu7sLhQ5GTkVbZ`
};
export default ___CSS_LOADER_EXPORT___;
